const _baseLink = 'https://api.github.com';
const _baseOwnerName = 'PlatformOfTrust';
const _baseReposName = 'standards';

export default class GithubApi {
    getData = async (pathToFile) => {
        const url = this._createURL(pathToFile);

        const res = await fetch(url, {
            headers: {
                'Authorization': 'token ee615be4190ff2aef2760b6b8709fd87edced7e0'
            }
        });

        if (!res.ok) {
            throw new Error(`Could not fetch ${url}, received ${res.status}`);
        }

        return await res.json();
    }

    _createURL(pathToFile) {
        return `${_baseLink}/repos/${_baseOwnerName}/${_baseReposName}/contents/${pathToFile}.jsonld`;
    }
}